import React, { useRef, createContext, useContext, type RefObject } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

import ApplicationLayout from "@rio-cloud/rio-uikit/ApplicationLayout";
import ApplicationHeader from "@rio-cloud/rio-uikit/ApplicationHeader";

import { useLocation } from "react-router-dom";

import SubNavigation from "@rio-cloud/rio-uikit/SubNavigation";
import { parseRoute } from "./routeHelper";
import { useRouteState } from "./routeHooks";
import { DefaultUserMenu } from "@rio-cloud/rio-user-menu-component";
import IframeResizer from "iframe-resizer-react";
import { config } from "../../../src/config";
import { ApplicationLayoutBodyNavigation } from "@rio-cloud/rio-uikit";
import CustomAssetTree from "../CustomAssetTree/CustomAssetTree";
import { CoreContext } from "../../../src/providers/CoreProvider";
import UnauthorizedScreen from "../../../src/screens/Unauthorized";

const RouteUpdater = () => {
  const { search } = useLocation();
  useRouteState(() => {
    parseRoute(search);
  });

  return null;
};

// Componentes específicos para o ROUTING
const RoutingMapItems = [
  {
    key: "map",
    route: <NavLink to="/routing/map/trips">Viagens em andamento</NavLink>,
  },
  {
    key: "map",
    route: <NavLink to="/routing/map/fleets">Posição atual dos veículos</NavLink>,
  },
];

const RoutingNavItems = [
  {
    key: "dashboard",
    route: <NavLink to="/volkstotal/dashboard">DASHBOARD</NavLink>,
  },
  { key: "despesas", route: <NavLink to="/volkstotal/expenses">DESPESAS</NavLink> },
  { key: "receitas", route: <NavLink to="/volkstotal/recipes">RECEITAS</NavLink> },
  { key: "settings", route: <NavLink to="/volkstotal/settings">CONFIGURAÇÕES</NavLink> },
];

const RoutingHeader = () => {
  const userMenuItem = (
    <DefaultUserMenu environment={process.env.NODE_ENV === "development" ? "development" : "production"} />
  );

  return (
    <ApplicationHeader
      appNavigator={<IframeResizer className="iFrameResizer" src={config.backend.MENU_SERVICE} />}
      homeRoute={<Link to={config.homeRoute || ""} />}
      appMenuItems={RoutingMapItems}
      label={<span style={{ textTransform: "none" }}>Volks|Total</span>}
      navItems={RoutingNavItems}
      actionBarItems={[userMenuItem]}
    />
  );
};

const RoutingMenuSubItems = () => {
  const items = {
    map: RoutingMapItems,
  };

  const location = useLocation();

  return (
    <ApplicationLayoutBodyNavigation className={"margin-0 padding-0"}>
      <SubNavigation
        className="padding-0 margin-0"
        navItems={location?.pathname.includes("/routing/map") ? items.map : []}
      />
    </ApplicationLayoutBodyNavigation>
  );
};

type AppContextType = {
  sidebarRef: React.RefObject<HTMLDivElement | null> | null;
};

const AppContext = createContext<AppContextType>({
  sidebarRef: null,
});

const RoutingLayout = () => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const { isUnauthorized } = useContext(CoreContext);

  return (
    <AppContext.Provider value={{ sidebarRef }}>
      <ApplicationLayout data-testid="app-layout">
        <ApplicationLayout.Header>
          <RoutingHeader />
        </ApplicationLayout.Header>

        <ApplicationLayout.Sidebar className="left">{!isUnauthorized && <CustomAssetTree />}</ApplicationLayout.Sidebar>

        <ApplicationLayout.Body
          innerClassName="padding-0"
          className="padding-0 margin-0"
          navigation={!isUnauthorized ? <RoutingMenuSubItems /> : undefined}
        >
          {isUnauthorized ? <UnauthorizedScreen /> : <Outlet />}
          <RouteUpdater />
        </ApplicationLayout.Body>
      </ApplicationLayout>
    </AppContext.Provider>
  );
};

export default RoutingLayout;
